import React, { Component } from 'react';
import {
    Button,
    Form,
    Label,
    Input,
    FormGroup,
    Col,
    Modal,
    ModalBody
} from 'reactstrap';
import PropTypes from 'prop-types';
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import ConfirmPassword from "../confirmPassword/ConfirmPasswordActivation.container";
import './ChangePassword.css';
import _ from 'lodash';
import { Utils } from './../../../utils/utils';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import { ROLES } from '../../../reducers/account/role';

class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            oldPassword: '',
            password: '',
            passwordConfirm: '',
            isModalOpen: false,
            userEmail: props.userEmail,
        };
    }

    componentWillUnmount() {
        this.props.onUnmount()
    }

    render() {
        return (
            <div className="change-password-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'change_password.change_email_alert')}
                >
                    {this.renderChangeEmailForm()}
                    <Form onSubmit={this.toggleModal}>
                        <h5 className="page-label">{_.get(this.props.translation, 'change_password.change_password')}</h5>
                        <FormGroup row>
                            <Label for="old-password" sm={3} >{_.get(this.props.translation, 'change_password.old_password_label') + "*"}</Label>
                            <Col sm={9}>
                                <Input type="password"
                                    id="old-password"
                                    value={this.state.oldPassword}
                                    onChange={this.handleChange('oldPassword')}
                                    required
                                    placeholder={_.get(this.props.translation, 'change_password.old_password_input_placeholder')}
                                />
                            </Col>
                        </FormGroup>
                        <ConfirmPassword
                            password={this.state.password}
                            passwordConfirm={this.state.passwordConfirm}
                            handleChange={this.handleChange}
                        />
                        <div className="change-password-submit">
                            <Button className="change-password-submit-button olive-green-btn"
                                    type='submit'
                                    disabled={this.state.password === '' || this.state.password !== this.state.passwordConfirm || !Utils.isValidPassword(this.state.password)}>
                                {_.get(this.props.translation, 'change_password.submit_button')}
                            </Button>
                        </div>
                        <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                            <ModalBody>
                                <h6>{_.get(this.props.translation, 'change_password.change_password_alert')}</h6>
                                <div className='modal-buttons-group'>
                                    <Button onClick={this.toggleModal} color="secondary">
                                        {_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                                    </Button>
                                    <Button onClick={this.handlePasswordChange} className="olive-green-btn">
                                        {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                                    </Button>
                                </div>
                            </ModalBody>
                        </Modal>
                    </Form>
                </FormWrapper>
            </div>
        );
    }

    renderChangeEmailForm = () => {
        return (
            <Form onSubmit={this.handleEmailChange}>
                <h5 className="page-label">{_.get(this.props.translation, 'change_password.change_email')}</h5>
                {
                    this.props.role === ROLES.EMPLOYEE ?
                    <div className="change-email-hint">{_.get(this.props.translation, 'change_password.change_email_hint')}</div> :
                    null
                }
                <FormGroup row>
                    <Label for="user-email" sm={3} >{_.get(this.props.translation, sharedLabelsPath.email_label)}*</Label>
                    <Col sm={9}>
                        <Input type="email"
                               id="user-email"
                               value={this.state.userEmail}
                               onChange={this.handleChange('userEmail')}
                               disabled={this.props.role === ROLES.SYS_ADMIN}
                               required
                               placeholder={_.get(this.props.translation, sharedLabelsPath.email_label)}
                        />
                    </Col>
                </FormGroup>
                <div className="user-email-submit">
                    <Button className="user-email-submit-button olive-green-btn"
                            type='submit'
                            disabled={this.state.userEmail === this.props.userEmail}>
                        {_.get(this.props.translation, 'change_password.update_email')}
                    </Button>
                </div>
            </Form>
        )
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({ [fieldKey]: e.target.value });
    };

    handleEmailChange = (e) => {
        e.preventDefault();
        this.props.onChangeEmail(this.state.userEmail);
    };

    toggleModal = (e) => {
        this.props.onUnmount();
        e.preventDefault();
        this.setState({isModalOpen: !this.state.isModalOpen});
    };

    handlePasswordChange = () => {
        if (this.state.password !== '' && this.state.password === this.state.passwordConfirm && Utils.isValidPassword(this.state.password)) {
            let data = {
                oldPassword: this.state.oldPassword,
                newPassword: this.state.password
            };
            this.props.onChangePassword(data);
        }
    };
}

ChangePassword.propTypes = {
    role: PropTypes.string,
    onChangePassword: PropTypes.func,
    translation: PropTypes.object.isRequired
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/accountManagement/changePassword/ChangePassword.js